import { Component, OnInit, Inject, Input, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { Options } from 'select2';
import { DialogData } from 'src/app/interfaces/interfaces';
import { SettingsProvider } from 'src/app/services/settings';
import { HttpClientProvider } from 'src/app/services/http-client';

declare var $: any;

import Swal from 'sweetalert2';

import { FormBuilder, FormControl, Validators } from '@angular/forms';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {map, startWith} from 'rxjs/operators';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { LoadingService } from 'src/app/services/loading.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-modal-addusers-organization',
  templateUrl: './modal-addusers-organization.component.html',
  styleUrls: ['./modal-addusers-organization.component.scss']
})
export class ModalAddUsersOrganizationComponent implements OnInit {

  public optionsSelect2: Options;

  users = null;
  roles: any[] = [];
  user = null;

  selectable = true;
  removable = true;
  addOnBlur = true;

  next:boolean = false;
  openFormCreateUser: boolean = false;

  separatorKeysCodes: number[] = [ENTER, COMMA];
  emailCtrl = new FormControl();
  filteredEmails: Observable<string[]>;
  emails: string[] = [];

  dataForm = this.fb.group({
		user_id: new FormControl(null,Validators.required),
		role_id: new FormControl([],Validators.required),
		user_email: new FormControl(null),
    user_first_name: new FormControl(null),
    user_last_name: new FormControl(null),
    user_cellphone: new FormControl(null),
	});

  @ViewChild('emailInput') emailInput: ElementRef<HTMLInputElement>;

  @ViewChild('auto', {static: false}) matAutocomplete: MatAutocomplete;

  constructor(
    private http: HttpClientProvider,
    private load: LoadingService,
    private toast: NotificationService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ModalAddUsersOrganizationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.roles = this.data.roles;
    this.filteredEmails = this.emailCtrl.valueChanges.pipe(
      startWith(null),
      map((email: string | null) => (email ? this._filter(email) : this.data.users.slice())),
    );
  }

  add(event: MatChipInputEvent): void {
    if (!this.matAutocomplete.isOpen) {
      // console.log(this.emails.length);
      const value = (event.value || '').trim();

      // const input = event.input;
      // const value = event.value;
      // * "this.emails.length < 1" -> evita que se añada más de un elemento
      if ((value || '').trim() && this.emails.length < 1) {
        if(!this.emails.includes(value.trim())&&this.validateEmail(event) /* && this.data.users.includes(value.trim()) */) {
          this.emails.push(value.trim());
        }
      }

      // if (input) {
      //   input.value = '';
      // }

      event.chipInput!.clear();
      this.emailCtrl.setValue(null);
    }
  }

  validateEmail(input) {
    console.log(input);
    var validRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (input.value.match(validRegex)) {
      // alert("Valid email address!");
      return true;
    } else {
      // alert("Invalid email address!");
      this.toast.error('Email Inválido', 'El Correo eletrónico introducido es incorrecto', 4000);
      return false;
    }
  }

  remove(email: string): void {
    const index = this.emails.indexOf(email);

    if (index >= 0) {
      this.emails.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    console.log(this.emails);
    // * "this.emails.length < 1" -> evita que se añada más de un elemento
    if (this.emails.length < 1) {
      if (!this.emails.includes(event.option.viewValue)) {
        this.emails.push(event.option.viewValue);
      }
      this.emailInput.nativeElement.value = '';
      this.emailCtrl.setValue(null);
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    let data = this.data.users.filter(email => {
      // email.toLowerCase().indexOf(filterValue) === 0;
      email.toLowerCase().includes(filterValue);
    });
    return data;
  }

  private _filterValidate(value: string): boolean {
    const filterValue = value.toLowerCase();
    let data = this.data.users.filter(email => {
      return email.toLowerCase().includes(filterValue);
    });
    console.log(data.length);
    if(data.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  accept() {
    this.data.dismiss_action = true;
    this.dialogRef.close({dismiss_action: this.data.dismiss_action});
  }

  ngOnInit() {

    this.optionsSelect2 = {
      multiple: true,
      theme: 'classic',
      closeOnSelect: false,
      width: '100%'
    };
    
  }

  submitForm() {
    if(this._filterValidate(this.emails[0])) {
      this.dataForm.patchValue({ user_id: this.emails[0] });
      this.openFormCreateUser = false;
    } else {
      this.dataForm.patchValue({ user_id: 0 });
      this.dataForm.patchValue({ user_email: this.emails[0] });
      this.openFormCreateUser = true;
    }
    this.next = true;
    console.log(this.dataForm.value);
  }

  submitFormOne() {
    console.log(this.dataForm.value);
    this.dialogRef.close({data: this.dataForm.value});
  }

}